import React from 'react';
import styles from './styles.module.scss';

import ImagePlaceholder from '../../Placeholder';

import Config, { spanish } from '../../../config/config';

import placeholderMobile from '../../../assets/placeholder/hero-mobile.jpg';
import placeholderDesktop from '../../../assets/placeholder/hero-desktop.jpg';

const Hero = ({ hero, isLoadingSearch }) => (
  <div className={styles.container}>
    <div className={styles.content}>
      {hero?.heroDesktop?.url && hero?.heroDesktop?.url && !isLoadingSearch ? (
        <picture className={`${styles.image} isLoading`}>
          <source
            srcSet={Config.cdn.cdn_path + hero?.heroDesktop?.url}
            media="(min-width: 760px)"
          />
          <img
            src={Config.cdn.cdn_path + hero?.heroMobile?.url}
            alt={hero?.NameSpanish}
          />
        </picture>
      ) : (
        <div className={styles.image}>
          <ImagePlaceholder
            mobile={placeholderMobile}
            desktop={placeholderDesktop}
          />
        </div>
      )}
      <div className={styles.description}>
        <h2>{spanish ? hero?.NameSpanish : hero?.NameEnglish}</h2>
        <p>{spanish ? hero?.DescriptionSpanish : hero?.DescriptionEnglish}</p>
      </div>
    </div>
  </div>
);

export default Hero;
